import React, { useCallback, useState } from 'react';
import {
  MessageBoxFunctionalLayout,
  Modal,
} from '../../../components/common/wixCommon';
import { noop } from '../../noop';
import { useBoolean } from '../useBoolean';
import { IAdditionalOptions, IModalOptions, ModalName } from './useModal.types';

export const useModal = (modalName: ModalName, modalOptions: IModalOptions) => {
  const {
    title,
    confirmText,
    cancelText,
    theme,
    onOk = noop,
    onCancel = noop,
    onClose = noop,
    message,
  } = modalOptions;

  const {
    value: isOpen,
    setFalse: closeModal,
    setTrue: openModal,
  } = useBoolean();

  const [additionalOptions, setAdditionalOptions] = useState({});

  const handleCancelClick = useCallback(() => {
    onCancel(additionalOptions);
    closeModal();
  }, [closeModal, onCancel, additionalOptions]);

  const handleCloseClick = useCallback(() => {
    onClose(additionalOptions);
    closeModal();
  }, [closeModal, onClose]);

  const handleOkClick = useCallback(() => {
    onOk(additionalOptions);
    closeModal();
  }, [closeModal, onOk, additionalOptions]);

  const onOpenModal = useCallback(
    (options: IAdditionalOptions) => {
      setAdditionalOptions(options);
      openModal();
    },
    [openModal, setAdditionalOptions],
  );

  return {
    onOpenModal,
    modalComponent: (
      <Modal
        isOpen={isOpen}
        shouldCloseOnOverlayClick={false}
        contentLabel={modalName}
      >
        <MessageBoxFunctionalLayout
          dataHook={modalName}
          title={title}
          confirmText={confirmText}
          cancelText={cancelText}
          theme={theme}
          onOk={handleOkClick}
          onCancel={handleCancelClick}
          onClose={handleCloseClick}
        >
          {message}
        </MessageBoxFunctionalLayout>
      </Modal>
    ),
  };
};
